<template>
  <div>
    <section
      id="tarjouksen-tiedot"
      class="section"
    >
      <h2 class="section__heading section__heading--alt2">
        Tarjouksen tiedot
      </h2>

      <div class="checkout__rows">
        <div class="checkout__header">
          <h3 class="checkout__header__heading">
            Perustiedot
          </h3>
        </div>

        <div class="checkout__subsection">
          <div class="field field--long">
            <label for="customer_reference">
              Asiakkaan viite
            </label>
            <input
              id="customer_reference"
              v-model="newOfferDetails.customer_reference"
              type="text"
              name="customer_reference"
              :disabled="!$store.getters.changesAllowed"
              @change="fieldChanged()"
              @keydown.enter.prevent
            >
          </div>
          <div class="field field--clear field--short">
            <label for="offer_date">
              Jättöpäivä
            </label>
            <div class="datepicker datepicker-trigger">
              <input
                id="offer_date"
                v-model="newOfferDetails.offer_date"
                v-validate="'date_format:DD.MM.YYYY'"
                type="text"
                name="offer_date"
                :disabled="!$store.getters.changesAllowed"
                @change="fieldChanged()"
                @keydown.enter.prevent
              >
              <AirbnbStyleDatepicker
                :trigger-element-id="'offer_date'"
                :mode="'single'"
                :months-to-show="1"
                :fullscreen-mobile="false"
                :date-one="datepickerOfferDate"
                @date-one-selected="selectOfferDate"
              />
            </div>
            <span
              v-if="errors.has('offer_date')"
              class="form-field-error-message"
            >{{ errors.first('offer_date') }}</span>
          </div>
          <div class="field field--clear">
            <label for="offer_terms">
              Toimitusehto
            </label>
            <input
              id="offer_terms"
              v-model="newOfferDetails.offer_terms"
              type="text"
              name="offer_terms"
              :disabled="!$store.getters.changesAllowed"
              @change="fieldChanged()"
              @keydown.enter.prevent
            >
          </div>
          <div class="field field--clear">
            <label for="offer_delivery">
              Kuljetus
            </label>
            <input
              id="offer_delivery"
              v-model="newOfferDetails.offer_delivery"
              type="text"
              name="offer_delivery"
              :disabled="!$store.getters.changesAllowed"
              @change="fieldChanged()"
              @keydown.enter.prevent
            >
          </div>
          <div class="field field--float">
            <label for="offer_installation">
              Asennus
            </label>
            <input
              id="offer_installation"
              v-model="newOfferDetails.offer_installation"
              type="text"
              name="offer_installation"
              :disabled="!$store.getters.changesAllowed"
              @change="fieldChanged()"
              @keydown.enter.prevent
            >
          </div>
          <div class="field field--no-label">
            <label class="checkbox">
              <input
                id="offer_installation_actual"
                v-model="newOfferDetails.offer_installation_actual"
                class="checkbox-input"
                type="checkbox"
                name="offer_installation_actual"
                :disabled="!$store.getters.changesAllowed"
                @change="fieldChanged()"
                @keydown.enter.prevent
              >
              <span class="checkbox-label checkbox-label--small checkbox-label--high">Veloitetaan toteutuneen mukaan</span>
            </label>
          </div>
          <div class="field field--clear">
            <label for="offer_delivery">
              Kierrätys
            </label>
            <input
              id="offer_recycling"
              v-model="newOfferDetails.offer_recycling"
              type="text"
              name="offer_recycling"
              :disabled="!$store.getters.changesAllowed"
              @change="fieldChanged()"
            >
          </div>
          <div class="field field--clear">
            <label for="offer_delivery_time">
              Toimitusaika
            </label>
            <input
              id="offer_delivery_time"
              v-model="newOfferDetails.offer_delivery_time"
              type="text"
              name="offer_delivery_time"
              :disabled="!$store.getters.changesAllowed"
              @change="fieldChanged()"
              @keydown.enter.prevent
            >
          </div>
          <div class="field field--clear">
            <label for="offer_payment_terms">
              Maksuehto
            </label>
            <textarea
              id="offer_payment_terms"
              v-model="newOfferDetails.offer_payment_terms"
              name="offer_payment_terms"
              :disabled="!$store.getters.changesAllowed"
              @change="fieldChanged()"
            />
          </div>
          <div class="field field--float field--short">
            <label for="offer_expiry">
              Voimassaoloaika
            </label>
            <div class="datepicker datepicker-trigger">
              <input
                id="offer_expiry"
                v-model="newOfferDetails.offer_expiry"
                v-validate="'date_format:DD.MM.YYYY'"
                type="text"
                name="offer_expiry"
                :disabled="!$store.getters.changesAllowed"
                @change="fieldChanged()"
                @keydown.enter.prevent
              >
              <AirbnbStyleDatepicker
                :trigger-element-id="'offer_expiry'"
                :mode="'single'"
                :months-to-show="1"
                :fullscreen-mobile="false"
                :date-one="datepickerOfferExpiry"
                @date-one-selected="selectOfferExpiry"
              />
            </div>
            <span
              v-if="errors.has('offer_expiry')"
              class="form-field-error-message"
            >{{ errors.first('offer_expiry') }}</span>
          </div>
          <div class="field field--clear">
            <label for="offer_guarantee">
              Takuu
            </label>
            <input
              id="offer_guarantee"
              v-model="newOfferDetails.offer_guarantee"
              type="text"
              name="offer_guarantee"
              :disabled="!$store.getters.changesAllowed"
              @change="fieldChanged()"
              @keydown.enter.prevent
            >
          </div>
          <div class="field field--long field--clear">
            <label for="offer_price_heading">
              Hinnan otsikko
            </label>
            <input
              id="offer_price_heading"
              v-model="newOfferDetails.offer_price_heading"
              type="text"
              name="offer_price_heading"
              :disabled="!$store.getters.changesAllowed"
              @change="fieldChanged()"
              @keydown.enter.prevent
            >
          </div>

          <div class="field field--long field--clear">
            <label class="checkbox">
              <input
                id="show_total"
                v-model="newOfferDetails.show_total"
                class="checkbox-input"
                type="checkbox"
                name="show_total"
                :disabled="!$store.getters.changesAllowed"
                @change="fieldChanged()"
                @keydown.enter.prevent
              >
              <span class="checkbox-label checkbox-label--last">Näytä yhteishinta tarjouksen toisella sivulla</span>
            </label>
          </div>
        </div>

        <div class="checkout__header">
          <div class="cart__search">
            <label
              for="salesperson"
              class="cart__search__label"
            >
              <h3 class="checkout__header__heading">Myyjä</h3>
            </label>

            <div
              v-if="currentUserHasManagerRole"
              class="cart__search__input-container"
            >
              <div class="select cart__search__input cart__search__input--with-icon">
                <select
                  id="salesperson"
                  v-model="selectedSalesPerson"
                  @change="fieldChanged()"
                  @keydown.enter.prevent
                >
                  <option :value="null">
                    {{ $modeoL10n.select }}
                  </option>
                  <option
                    v-for="salesPerson in salesPersons"
                    :key="salesPerson.id"
                    :value="salesPerson"
                  >
                    {{ salesPerson.first_name }} {{ salesPerson.last_name }} ({{ salesPerson.code }})
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="checkout__subsection">
          <p v-if="selectedSalesPerson">
            <template v-if="selectedSalesPerson.first_name || selectedSalesPerson.last_name">
              {{ selectedSalesPerson.first_name }} {{ selectedSalesPerson.last_name }}<br>
            </template>
            <template v-if="selectedSalesPerson.title">
              {{ selectedSalesPerson.title }}<br>
            </template>
            <template v-if="selectedSalesPerson.email">
              {{ selectedSalesPerson.email }}<br>
            </template>
            <template v-if="selectedSalesPerson.phone">
              {{ selectedSalesPerson.phone }}
            </template>
          </p>
          <div
            v-else
            class="checkout__subsection__empty"
          >
            Ei valittua myyjää
          </div>
        </div>

        <div class="checkout__header">
          <h3 class="checkout__header__heading">
            Liitteet
          </h3>
        </div>

        <div class="checkout__subsection">
          <label class="checkbox">
            <input
              id="attachments_terms"
              v-model="newOfferDetails.attachments_terms"
              class="checkbox-input"
              type="checkbox"
              name="attachments_terms"
              :disabled="!$store.getters.changesAllowed"
              @change="fieldChanged()"
              @keydown.enter.prevent
            >
            <span class="checkbox-label checkbox-label--last">Sopimusehdot</span>
          </label>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="checkout__rows">
        <div class="grid-wrap">
          <div class="grid-col grid-col-right bp2-col-one-half">
            <div class="checkout__offer-status select">
              <span
                class="checkout__offer-status__detail"
                :class="'checkout__offer-status__detail--' + newOfferDetails.status"
              />
              <select
                v-model="newOfferDetails.status"
                :disabled="!$store.getters.changesAllowed"
                @change="fieldChanged()"
                @keydown.enter.prevent
              >
                <option value="offer-draft">
                  Luonnos
                </option>
                <option value="offer">
                  Valmis
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="grid-wrap">
          <div class="grid-col grid-col-right bp2-col-one-half">
            <a
              class="checkout__button btn btn--secondary btn--block"
              target="_blank"
              href="?format=pdf&show_prices=true"
            >Lataa tiedot PDF:nä</a>
          </div>

          <div
            v-if="$store.getters.changesAllowed"
            class="checkout__delete-offer-container grid-col bp2-col-one-half"
          >
            <button
              type="submit"
              class="checkout__delete-offer"
              @click.prevent="confirmOfferDelete()"
            >
              Poista tarjous
            </button>
          </div>
        </div>
      </div>
    </section>

    <delete-offer-modal
      :offer-id="offerId"
      :display="displayModal"
      :nonce="nonce"
      @cancel="displayModal = false"
    />
  </div>
</template>

<script>
import axios from 'axios';
import format from 'date-fns/format'
import moment from 'moment';
import DeleteOfferModal from '../delete-offer-modal.vue';
import { EventBus } from '../../event-bus';
import _ from 'lodash';

export default {
    components: {
        DeleteOfferModal,
    },
    props: {
        offerDetails: {
            type: Object,
            default: function(){
                return {};
            },
        },
        nonce: {
            type: String,
            default: '',
        },
        offerId: {
            type: Number,
            default: 0,
        },
        salesPersons: {
            type: Array,
            default: function(){
                return [];
            },
        },
        currentUserHasManagerRole: Boolean,
    },
    data: function () {
        return {
            newOfferDetails: this.offerDetails,
            datepickerOfferDate: '',
            datepickerOfferExpiry: '',
            displayModal: false,
            deletionConfirmed: false,
            deletionFailed: false,
            selectedSalesPerson: null,
        }
    },
    mounted: function() {
        this.$store.commit('setOfferDetails', this.newOfferDetails);
        this.salesPersons.forEach( (salesPerson) => {
            if (salesPerson.id == this.offerDetails.salesperson) {
                this.selectedSalesPerson = salesPerson;
            }
        });

        if (this.newOfferDetails.offer_date) {
            this.datepickerOfferDate = moment(this.newOfferDetails.offer_date, 'DD.MM.YYYY').format('YYYY-MM-DD');
        }
        if (this.newOfferDetails.offer_expiry) {
            this.datepickerOfferExpiry = moment(this.newOfferDetails.offer_expiry, 'DD.MM.YYYY').format('YYYY-MM-DD');
        }
    },
    methods: {
        fieldChanged() {
            if (this.selectedSalesPerson) {
                this.newOfferDetails.salesperson = this.selectedSalesPerson.id;
            }
            this.$store.commit('setOfferDetails', this.newOfferDetails);
            this.saveDetails();
        },
        saveDetails() {
            let request = {
                'offerdetails': this.newOfferDetails,
            };

            let config = {
                headers: {
                    'X-WP-Nonce': this.nonce,
                },
            }

            axios.post('/wp-json/modeo/v2/cart/save_offer_details', request, config)
            .catch((error) => {
                if ( error.response ) {

                    if ( error.response.status === 403 && error.response.data.code === 'Forbidden' ) {
                        let productAddedToCartData = {
                            message: this.$modeoL10n.offer_modification_failed,
                            notificationType: 'single-message',
                        };
                        EventBus.$emit( 'notify', productAddedToCartData );
                    }

                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log( error.response.data );
                    console.log( error.response.status );
                    console.log( error.response.headers );
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log( 'Error', error.message );
                }
                console.log( error.config );
            });
        },
        selectOfferDate(val) {
            this.datepickerOfferDate = val; // value needs to be added manually as we can't use v-model
            this.updateDate(val, 'offer_date');

        },
        selectOfferExpiry(val) {
            this.datepickerOfferExpiry = val;
            this.updateDate(val, 'offer_expiry');
        },
        updateDate(val, key) {
            let formattedDate = this.formatDate(val);
            let tempOfferDetails = _.clone(this.newOfferDetails);

            if (formattedDate != tempOfferDetails[key]) {
                tempOfferDetails[key] = formattedDate;
                this.newOfferDetails = tempOfferDetails;
                this.fieldChanged();
            }
        },
        confirmOfferDelete() {
            this.displayModal = true;
        },
        formatDate(date) {
            return date ? format(date, 'DD.MM.YYYY') : '';
        },
    },
}
</script>
